import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { APP_CONFIG, IAppConfig } from "@webapp/core/app-config/models/app-config.models";
import { LoggingService } from "@webapp/core/logging/services/logging.service";

export const quantiveStaticBlobURL = "https://cdn.quantivestatic.com/dist/img/quantive-circle-logo-left-navigation.svg";
@Injectable({
  providedIn: "root",
})
export class QuantiveStaticBlockCheckerService {
  private loggingService: LoggingService;
  constructor(@Inject(APP_CONFIG) private appConfig: IAppConfig, private httpClient: HttpClient) {
    this.loggingService = new LoggingService(this.appConfig.logging, "spa");
  }

  public checkIfQuantivestaticIsBlocked(): void {
    const headers = new HttpHeaders().set("Content-Type", "image/svg+xml; charset=utf-8");
    this.httpClient.get(quantiveStaticBlobURL, { headers: headers, responseType: "text" }).subscribe({
      error: (err) => {
        if (err.status >= 400 && err.status < 500) {
          this.loggingService.logError({
            name: "quantivestatic_blocked_by_customer",
            message:
              "It seems you have a firewall rule blocking some of the Quantive Results resources. Please contact Quantive Support (support@quantive.com) for more information about the full list of subdomains that must be whitelisted in order for the Quantive Results application to operate properly.\nBlocked domain in question - https://cdn.quantivestatic.com",
          });
          alert(
            "It seems you have a firewall rule blocking some of the Quantive Results resources. Please contact Quantive Support (support@quantive.com) for more information about the full list of subdomains that must be whitelisted in order for the Quantive Results application to operate properly.\nBlocked domain in question - https://cdn.quantivestatic.com"
          );
        }
      },
    });
  }
}
